import styled from 'styled-components';

const NavContainer = styled.nav`
  height: 6rem;
  display: flex;
  background-color: #010535;
  color: #ffffff;
  justify-content:space-between;

  .nav-center {
    width: 100vw;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left:2rem;
    margin-right:1rem;
  }

  .nav-header img {
    margin-right:auto;
    width: 175px;
  }
  .nav-toggle {
    background: transparent;
    border: none;
    color: #ffffff;
    cursor: pointer;
    svg {
      font-size: 1.8rem;
    }
  }

  .nav-right {
    display: flex;
    justify-content:end;
    align-items: center;
    gap: 15px
  }

  .nav-links {
    display: none;
  }
  .cart-btn-wrapper {
    display: none;
  }
  @media (min-width: 992px) {
    .nav-toggle {
      display: none;
    }
    .nav-center {
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
    }
    .nav-links {
      display: flex;
      gap: 15px;
      justify-content: center;
      li {
        margin: 0 0.5rem;
      }
      a {
        color: #ffffff;
        font-size: 0.9rem;
        text-transform: capitalize;
        letter-spacing: var(--spacing);
        position: relative;
        padding:0.6rem;
        font-weight: 400;

        &:hover::after,
        &.active::after {
          content: '';
          bottom: 0;
          left: 0;
          right: 0;
          height: 2px;
          background: var(--clr-primary-7);
        }
        &:hover,
        &.active {
        color: #d3a143;
        text-decoration-thickness: 2px;
        text-underline-offset: 5px; 
        text-decoration:underline;
        border-radius:5px;
        }
      }
    }
    .cart-btn-wrapper {
      display: grid;
      justify-items: end;
    }
  }

  .mobile-controls{
  display:flex;
  gap:1rem;
  }
@media (max-width: 768px) {
 .nav-links{
 a{
 font-size:10px}
 }
}
  @media (max-width: 576px) {
    .nav-header {
      img {
        width: 130px;
      }
  }
`;

export default NavContainer;
